import React from 'react';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import CodeIcon from '@mui/icons-material/Code';
import SuperscriptIcon from '@mui/icons-material/Superscript';
import SubscriptIcon from '@mui/icons-material/Subscript';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ChecklistIcon from '@mui/icons-material/Checklist';
import DataObjectIcon from '@mui/icons-material/DataObject';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncrease';
import FormatIndentDecreaseIcon from '@mui/icons-material/FormatIndentDecrease';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import HtmlIcon from '@mui/icons-material/Html';
import ListAltIcon from '@mui/icons-material/ListAlt';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import constants from '../../constants';
const { EDITOR_COMMAND_ICON_MAP } = constants;

const EditorButtonIcon = (props) => {
  switch (props.name) {
    case 'bold':
      return <FormatBoldIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'italic':
      return <FormatItalicIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'underline':
      return (
        <FormatUnderlinedIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />
      );
    case 'code':
      return <CodeIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'superscript':
      return <SuperscriptIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'subscript':
      return <SubscriptIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'strikethrough':
      return (
        <StrikethroughSIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />
      );
    case 'highlight':
      return <BorderColorIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'horizontal_rule':
      return <HorizontalRuleIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'check_list':
      return <ChecklistIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'checkbox':
      return <CheckBoxIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'code_block':
      return <DataObjectIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'clear_all':
      return <ClearAllIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'unordered_list':
    case 'bulleted-list':
      return (
        <FormatListBulletedIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />
      );
    case 'ordered_list':
    case 'numbered-list':
      return (
        <FormatListNumberedIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />
      );
    case 'indent_list':
      return (
        <FormatIndentIncreaseIcon
          sx={{ color: '#ffffff', fontSize: '1.5rem' }}
        />
      );
    case 'outdent_list':
      return (
        <FormatIndentDecreaseIcon
          sx={{ color: '#ffffff', fontSize: '1.5rem' }}
        />
      );
    case 'attach_file':
      return <AttachFileIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'view_html':
      return <HtmlIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'toggle_attachments':
      return <ListAltIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'link':
      return <InsertLinkIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'undo':
      return <UndoIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    case 'redo':
      return <RedoIcon sx={{ color: '#ffffff', fontSize: '1.5rem' }} />;
    default:
      return (
        <span>
          <i className="material-icons">
            {EDITOR_COMMAND_ICON_MAP[props.name]}
          </i>
        </span>
      );
  }
};

export default EditorButtonIcon;
